import Link from 'components/Router/Link'

import { StyledLink } from './styled'

function getLinkComponent(href) {
  if (!href) return
  return (href.pathname || href).match(/^http|^www|^mailto/) ? 'a' : 'Link'
}

function TextLink({ color = 'primary', href, target, onClick, children, className, dataTestId }) {
  const componentName = getLinkComponent(href)

  const linkProps = {
    className,
    color,
    onClick,
  }

  if (componentName === 'a') {
    linkProps.as = componentName
    linkProps.href = href
    linkProps.target = target
  } else if (componentName === 'Link') {
    linkProps.as = Link
    linkProps.to = href
    linkProps.target = target
  }

  return (
    <StyledLink data-testid={dataTestId} {...linkProps}>
      {children}
    </StyledLink>
  )
}

export default TextLink
